import React from "react";
import "./register.css";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Navbar } from "./../../components";
import Countries from "./../../../data/countries";
import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import { BsPlusLg } from "react-icons/bs";
import Certificate from "./../../../assets/images/signatureDocument.jpg";
import Months from "./../../../data/months";
import Date from "./../../../data/date";
import Years from "./../../../data/years";
import { useAlert } from "react-alert";
import Loading from "./../../../assets/svg/loading.svg";
import { useNavigate } from "react-router-dom";
import { BsEyeFill, BsEyeSlashFill } from "react-icons/bs";
const Input = styled("input")({
  display: "none",
});
const Register = () => {
  const navigate = useNavigate();
  const alert = useAlert();
  const [passwordShow, setPasswordShow] = React.useState(false);
  const [confirmPasswordShow, setConfirmPasswordShow] = React.useState(false);
  const [activeTab, setActiveTab] = React.useState("Student");
  const [countryCode, setCountryCode] = React.useState("");
  const [selectedCountryCode, setSelectedCountryCode] = React.useState();
  const [certificateShow, setCertificateShow] = React.useState(false);
  const handleDropdownChange = (e) => {
    setCountryCode(e.target.value);
    Countries.map((v, i) => {
      if (Countries[i].alpha2Code === e.target.value) {
        setSelectedCountryCode(Countries[i].callingCode);
      }
    });
  };
  const TabsData = [
    {
      title: "Student",
    },
    {
      title: "Tutor",
    },
    {
      title: "Admin Staff",
    },
  ];
  const State = [
    {
      title: "Balochistan",
    },
    {
      title: "Punjab",
    },
    {
      title: "Sindh",
    },
    {
      title: "KPK",
    },
  ];

  // Student Details
  const [studentFistName, setStudentFirstName] = React.useState("");
  const [studentLastName, setStudentLastName] = React.useState("");
  const [studentEmail, setStudentEmail] = React.useState("");
  const [studentBirthdayMonth, setStudentBirthdayMonth] = React.useState("");
  const [studentBirthdayDate, setStudentBirthdayDate] = React.useState("");
  const [studentBirthdayYear, setStudentBirthdayYear] = React.useState("");
  const [studentGender, setStudentGender] = React.useState("");
  const [studentLanguage, setStudentLanguage] = React.useState("");
  const [studentCountry, setStudentCountry] = React.useState("");
  const [studentState, setStudentState] = React.useState("");
  const [studentCity, setStudentCity] = React.useState("");
  const [studentMobileNumber, setStudentMobileNumber] = React.useState("");
  const [studentAddress, setStudentAddress] = React.useState("");
  const [studentPassword, setStudentPassword] = React.useState("");
  const [studentConfirmPassword, setStudentConfirmPassword] =
    React.useState("");
  const [studentGrade, setStudentGrade] = React.useState("");
  const [studentLoading, setStudentLoading] = React.useState(false);
  const studentFistNameRef = React.useRef();
  const studentLastNameRef = React.useRef();
  const studentEmailRef = React.useRef();
  const studentBirthdayMonthRef = React.useRef();
  const studentBirthdayDateRef = React.useRef();
  const studentBirthdayYearRef = React.useRef();
  const studentGenderRef = React.useRef();
  const studentLanguageRef = React.useRef();
  const studentCountryRef = React.useRef();
  const studentStateRef = React.useRef();
  const studentCityRef = React.useRef();
  const studentCountryCodeRef = React.useRef();
  const studentMobileNumberRef = React.useRef();
  const studentAddressRef = React.useRef();
  const studentPasswordRef = React.useRef();
  const studentConfirmPasswordRef = React.useRef();
  const studentGradeRef = React.useRef();
  const StudentDetailsHandler = () => {
    if (studentFistName === "") {
      alert.error(<div className="alert-message">first name required</div>);
      studentFistNameRef.current.focus();
    } else if (studentLastName === "") {
      alert.error(<div className="alert-message">last name required</div>);
      studentLastNameRef.current.focus();
    } else if (studentEmail === "") {
      alert.error(
        <div className="alert-message">please type valid email address</div>
      );
      studentEmailRef.current.focus();
    } else if (studentBirthdayMonth === "") {
      alert.error(
        <div className="alert-message">please select birthday month</div>
      );
      studentBirthdayMonthRef.current.focus();
    } else if (studentBirthdayDate === "") {
      alert.error(
        <div className="alert-message">please select birthday date</div>
      );
      studentBirthdayDateRef.current.focus();
    } else if (studentBirthdayYear === "") {
      alert.error(
        <div className="alert-message">please select birthday year</div>
      );
      studentBirthdayYearRef.current.focus();
    } else if (studentGender === "") {
      alert.error(<div className="alert-message">please select gender</div>);
      studentGenderRef.current.focus();
    } else if (studentLanguage === "") {
      alert.error(<div className="alert-message">please select Language</div>);
      studentLanguageRef.current.focus();
    } else if (studentCountry === "") {
      alert.error(<div className="alert-message">please select country</div>);
      studentCountryRef.current.focus();
    } else if (studentState === "") {
      alert.error(<div className="alert-message">please select state</div>);
      studentStateRef.current.focus();
    } else if (studentCity === "") {
      alert.error(<div className="alert-message">please select city</div>);
      studentCityRef.current.focus();
    } else if (countryCode === "") {
      alert.error(
        <div className="alert-message">please select country code</div>
      );
      studentCountryCodeRef.current.focus();
    } else if (studentMobileNumber === "") {
      alert.error(
        <div className="alert-message">please add valid mobile number</div>
      );
      studentMobileNumberRef.current.focus();
    } else if (studentAddress === "") {
      alert.error(<div className="alert-message">please add address</div>);
      studentAddressRef.current.focus();
    } else if (studentPassword === "" || studentPassword.length < 6) {
      alert.error(
        <div className="alert-message">
          You have to enter password at least 6 digit!
        </div>
      );
      studentPasswordRef.current.focus();
    } else if (studentPassword !== studentConfirmPassword) {
      alert.error(
        <div className="alert-message">
          confirmation password do not match to password
        </div>
      );
      studentConfirmPasswordRef.current.focus();
    } else if (studentGrade === "") {
      alert.error(
        <div className="alert-message">please select your grade</div>
      );
      studentGradeRef.current.focus();
    } else {
      setStudentLoading(true);
      const StudentDetailsObject = {
        firstName: studentFistName,
        lastName: studentLastName,
        email: studentEmail,
        birthdayMonth: studentBirthdayMonth,
        birthdayDate: studentBirthdayDate,
        birthdayYear: studentBirthdayYear,
        gender: studentGender,
        language: studentLanguage,
        country: studentCountry,
        state: studentState,
        city: studentCity,
        countryCode: selectedCountryCode,
        mobileNumber: studentMobileNumber,
        address: studentAddress,
        password: studentPassword,
        greade: studentGrade,
      };
      alert.success(
        <div className="alert-message">you have successfully saved</div>
      );
      console.log(StudentDetailsObject);
      setTimeout(() => {
        setCertificateShow(true);
        setStudentLoading(false);
      }, 2000);
    }
  };

  // Turor
  const [tutorFirstName, setTutorFirstName] = React.useState("");
  const [tutorLastName, setTutorLastName] = React.useState("");
  const [tutorEmail, setTutorEmail] = React.useState("");
  const [tutorBirthdatMonth, setTutorBirthdayMonth] = React.useState("");
  const [tutorBirthdatDate, setTutorBirthdayDate] = React.useState("");
  const [tutorBirthdayYear, setTutorBirthdayYear] = React.useState("");
  const [tutorGender, setTutorGender] = React.useState("");
  const [tutorLanguage, setTutorLanguage] = React.useState("");
  const [tutorCountry, setTutorCountry] = React.useState("");
  const [tutorState, setTutorState] = React.useState("");
  const [tutorCity, setTutorCity] = React.useState("");
  const [tutorMobileNumber, setTutorMobileNumber] = React.useState("");
  const [tutorAddress, setTutorAddress] = React.useState("");
  const [tutorPassword, setTutorPassword] = React.useState("");
  const [tutorConfirmPassword, setTutorConfirmPassword] = React.useState("");
  const [tutorEducation, setTutorEducation] = React.useState("");
  const [tutorExpert, setTutorExpert] = React.useState("");
  const [tutorExperience, setTutorExperience] = React.useState("");
  const [tutorLoading, setTutorLoading] = React.useState(false);
  const tutorFirstNameRef = React.useRef();
  const tutorLastNameRef = React.useRef();
  const tutorEmailRef = React.useRef();
  const tutorBirthdatMonthRef = React.useRef();
  const tutorBirthdatDateRef = React.useRef();
  const tutorBirthdayYearRef = React.useRef();
  const tutorGenderRef = React.useRef();
  const tutorLanguageRef = React.useRef();
  const tutorCountryRef = React.useRef();
  const tutorStateRef = React.useRef();
  const tutorCityRef = React.useRef();
  const tutorCountryCodeRef = React.useRef();
  const tutorMobileNumberRef = React.useRef();
  const tutorAddressRef = React.useRef();
  const tutorPasswordRef = React.useRef();
  const tutorConfirmPasswordRef = React.useRef();
  const tutorEducationRef = React.useRef();
  const tutorExpertRef = React.useRef();
  const tutorExperienceRef = React.useRef();
  const TutorHandler = () => {
    if (tutorFirstName === "") {
      alert.error(<div className="alert-message">first name required</div>);
      tutorFirstNameRef.current.focus();
    } else if (tutorLastName === "") {
      alert.error(<div className="alert-message">last name required</div>);
      tutorLastNameRef.current.focus();
    } else if (tutorEmail === "") {
      alert.error(
        <div className="alert-message">please type vaild email address</div>
      );
      tutorEmailRef.current.focus();
    } else if (tutorBirthdatMonth === "") {
      alert.error(
        <div className="alert-message">please select birthday month</div>
      );
      tutorBirthdatMonthRef.current.focus();
    } else if (tutorBirthdatDate === "") {
      alert.error(
        <div className="alert-message">please select birthday date</div>
      );
      tutorBirthdatDateRef.current.focus();
    } else if (tutorBirthdayYear === "") {
      alert.error(
        <div className="alert-message">please select birthday year</div>
      );
      tutorBirthdayYearRef.current.focus();
    } else if (tutorGender === "") {
      alert.error(<div className="alert-message">please select gender</div>);
      tutorGenderRef.current.focus();
    } else if (tutorLanguage === "") {
      alert.error(<div className="alert-message">please select language</div>);
      tutorLanguageRef.current.focus();
    } else if (tutorCountry === "") {
      alert.error(<div className="alert-message">please select country</div>);
      tutorCountryRef.current.focus();
    } else if (tutorState === "") {
      alert.error(<div className="alert-message">please select state</div>);
      tutorStateRef.current.focus();
    } else if (tutorCity === "") {
      alert.error(<div className="alert-message">please select city</div>);
      tutorCityRef.current.focus();
    } else if (countryCode === "") {
      alert.error(
        <div className="alert-message">please select county code</div>
      );
      tutorCountryCodeRef.current.focus();
    } else if (tutorMobileNumber === "") {
      alert.error(
        <div className="alert-message">please enter valid mobile number</div>
      );
      tutorMobileNumberRef.current.focus();
    } else if (tutorAddress === "") {
      alert.error(<div className="alert-message">please enter address</div>);
      tutorAddressRef.current.focus();
    } else if (tutorPassword === "" || tutorPassword.length < 6) {
      alert.error(
        <div className="alert-message">
          You have to enter password at least 6 digit!
        </div>
      );
      tutorPasswordRef.current.focus();
    } else if (tutorConfirmPassword !== tutorPassword) {
      alert.error(
        <div className="alert-message">
          confirmation password do not match to password
        </div>
      );
      tutorConfirmPasswordRef.current.focus();
    } else if (tutorEducation === "") {
      alert.error(
        <div className="alert-message">please add your education</div>
      );
      tutorEducationRef.current.focus();
    } else if (tutorExpert === "") {
      alert.error(
        <div className="alert-message">please add subject of Expert</div>
      );
      tutorExpertRef.current.focus();
    } else if (tutorExperience === "") {
      alert.error(
        <div className="alert-message">please Add Your Experience</div>
      );
      tutorExperienceRef.current.focus();
    } else {
      setTutorLoading(true);
      const TutorObject = {
        firstName: tutorFirstName,
        lastName: tutorLastName,
        email: tutorEmail,
        birthdayMonth: tutorBirthdatMonth,
        birthdayDate: tutorBirthdatDate,
        birthdayYear: tutorBirthdayYear,
        gender: tutorGender,
        language: tutorLanguage,
        country: tutorCountry,
        state: tutorState,
        city: tutorCity,
        countryCode: selectedCountryCode,
        mobileNumber: tutorMobileNumber,
        address: tutorAddress,
        password: tutorPassword,
        education: tutorEducation,
        expert: tutorExpert,
        experience: tutorExperience,
      };
      alert.success(
        <div className="alert-message">you have successfully saved</div>
      );
      console.log(TutorObject);
      setTimeout(() => {
        setCertificateShow(true);
        setTutorLoading(false);
      }, 2000);
    }
  };

  // Admin Staff
  const [staffFirstName, setStaffFirstName] = React.useState("");
  const [staffLastName, setStaffLastName] = React.useState("");
  const [staffEmail, setStaffEmail] = React.useState("");
  const [staffRole, setStaffRole] = React.useState("");
  const [staffBirthdayMonth, setStaffBirthdayMonth] = React.useState("");
  const [staffBirthdayDate, setStaffBirthdayDate] = React.useState("");
  const [staffBirthdayYear, setStaffBirthdayYear] = React.useState("");
  const [staffGender, setStaffGender] = React.useState("");
  const [staffLanguage, setStaffLanguage] = React.useState("");
  const [staffCountry, setStaffCountry] = React.useState("");
  const [staffState, setStaffState] = React.useState("");
  const [staffCity, setStaffCity] = React.useState("");
  const [staffMobileNumber, setStaffMobileNumber] = React.useState("");
  const [staffLoading, setStaffLoading] = React.useState(false);
  const staffFirstNameRef = React.useRef();
  const staffLastNameRef = React.useRef();
  const staffEmailRef = React.useRef();
  const staffRoleRef = React.useRef();
  const staffBirthdayMonthRef = React.useRef();
  const staffBirthdayDateRef = React.useRef();
  const staffBirthdayYearRef = React.useRef();
  const staffGenderRef = React.useRef();
  const staffLanguageRef = React.useRef();
  const staffCountryRef = React.useRef();
  const staffStateRef = React.useRef();
  const staffCityRef = React.useRef();
  const staffCountryCodeRef = React.useRef();
  const staffMobileNumberRef = React.useRef();
  const AdminStaffHandler = () => {
    if (staffFirstName === "") {
      alert.error(<div className="alert-message">first name required</div>);
      staffFirstNameRef.current.focus();
    } else if (staffLastName === "") {
      alert.error(<div className="alert-message">last name required</div>);
      staffLastNameRef.current.focus();
    } else if (staffEmail === "") {
      alert.error(
        <div className="alert-message">please enter valid email address</div>
      );
      staffEmailRef.current.focus();
    } else if (staffRole === "") {
      alert.error(<div className="alert-message">please enter staff role</div>);
      staffRoleRef.current.focus();
    } else if (staffBirthdayMonth === "") {
      alert.error(
        <div className="alert-message">please select birthday month</div>
      );
      staffBirthdayMonthRef.current.focus();
    } else if (staffBirthdayDate === "") {
      alert.error(
        <div className="alert-message">please select birthday date</div>
      );
      staffBirthdayDateRef.current.focus();
    } else if (staffBirthdayYear === "") {
      alert.error(
        <div className="alert-message">please select birthday year</div>
      );
      staffBirthdayYearRef.current.focus();
    } else if (staffGender === "") {
      alert.error(<div className="alert-message">please select gender</div>);
      staffGenderRef.current.focus();
    } else if (staffLanguage === "") {
      alert.error(<div className="alert-message">please select language</div>);
      staffLanguageRef.current.focus();
    } else if (staffCountry === "") {
      alert.error(<div className="alert-message">please select country</div>);
      staffCountryRef.current.focus();
    } else if (staffState === "") {
      alert.error(<div className="alert-message">please select state</div>);
      staffStateRef.current.focus();
    } else if (staffCity === "") {
      alert.error(<div className="alert-message">please select city</div>);
      staffCityRef.current.focus();
    } else if (countryCode === "") {
      alert.error(
        <div className="alert-message">please select country code</div>
      );
      staffCountryCodeRef.current.focus();
    } else if (staffMobileNumber === "") {
      alert.error(
        <div className="alert-message">please enter valid mobile number</div>
      );
      staffMobileNumberRef.current.focus();
    } else {
      setStaffLoading(true);
      const AdminStaffObject = {
        firstName: staffFirstName,
        lastName: staffLastName,
        email: staffEmail,
        role: staffRole,
        birthdayMonth: staffBirthdayMonth,
        birthdayDate: staffBirthdayDate,
        birthdayYear: staffBirthdayYear,
        gender: staffGender,
        language: staffLanguage,
        country: staffCountry,
        state: staffState,
        city: staffCity,
        countryCode: selectedCountryCode,
        mobileNumber: staffMobileNumber,
      };
      alert.success(
        <div className="alert-message">you have successfully saved</div>
      );
      console.log(AdminStaffObject);
      setTimeout(() => {
        setCertificateShow(true);
        setStaffLoading(false);
      }, 2000);
    }
  };

  // Submit
  const [submitLoading, setSubmitLoading] = React.useState(false);
  const SubmitHandler = () => {
    setSubmitLoading(true);
    alert.success(
      <div className="alert-message">
        congratulations, your account has been successfully create.
      </div>
    );
    setTimeout(() => {
      if (activeTab === "Student") {
        navigate("/student-panel/dashboard");
        window.location.reload();
      } else if (activeTab === "Tutor") {
        navigate("/tutor-panel/dashboard");
        window.location.reload();
      } else if (activeTab === "Admin Staff") {
        navigate("/home");
      }
      setSubmitLoading(false);
    }, 2000);
  };
  return (
    <div className="register-container">
      <Navbar
        title="login"
        HeaderNavigateHandler={() => {
          navigate("/login");
        }}
      />
      <div className="register-header-main">
        <p className="register-header-heading">Start lerning</p>
        <p className="register-header-description">Register for Amaf classes</p>
      </div>
      <div className="register-form-main">
        {!certificateShow ? (
          <>
            <p className="register-from-heading">Register with amaf classes</p>
            <div className="register-tabs-main">
              {TabsData.map((tabsValue, TabsIndex) => {
                return (
                  <button
                    key={TabsIndex}
                    className={
                      activeTab === tabsValue.title
                        ? "register-active-tab"
                        : "register-tab"
                    }
                    onClick={() => setActiveTab(tabsValue.title)}
                  >
                    <p
                      className={
                        activeTab === tabsValue.title
                          ? "register-active-tab-title"
                          : "register-tab-title"
                      }
                    >
                      {tabsValue.title}
                    </p>
                  </button>
                );
              })}
            </div>
            {activeTab === "Student" && (
              <div className="form-container">
                <p className="register-form-heading">Student details</p>
                <Box sx={{ flexGrow: 1 }}>
                  <Grid container spacing={2}>
                    <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                      <div>
                        <p className="input-heading">First name</p>
                        <input
                          type="text"
                          name="firstName"
                          className="input"
                          placeholder="Name"
                          value={studentFistName}
                          ref={studentFistNameRef}
                          onChange={(e) => setStudentFirstName(e.target.value)}
                        />
                      </div>
                    </Grid>
                    <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                      <div>
                        <p className="input-heading">Last name</p>
                        <input
                          type="text"
                          name="lastName"
                          className="input"
                          placeholder="Name"
                          value={studentLastName}
                          ref={studentLastNameRef}
                          onChange={(e) => setStudentLastName(e.target.value)}
                        />
                      </div>
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                      <div>
                        <p className="input-heading">Email Address</p>
                        <input
                          type="email"
                          name="email"
                          required="require"
                          className="input"
                          placeholder="Email address"
                          value={studentEmail}
                          ref={studentEmailRef}
                          onChange={(e) => setStudentEmail(e.target.value)}
                        />
                      </div>
                    </Grid>
                  </Grid>
                  <p className="input-heading">birthday</p>
                  <Grid container spacing={2}>
                    <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
                      <div>
                        <select
                          className="input"
                          ref={studentBirthdayMonthRef}
                          onChange={(e) =>
                            setStudentBirthdayMonth(e.target.value)
                          }
                        >
                          <option value="">Month</option>
                          {Months.map((monthValue, monthIndex) => {
                            return (
                              <option
                                key={monthIndex}
                                value={monthValue.monthName}
                              >
                                {monthValue.monthName}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </Grid>
                    <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
                      <div>
                        <select
                          className="input"
                          ref={studentBirthdayDateRef}
                          onChange={(e) =>
                            setStudentBirthdayDate(e.target.value)
                          }
                        >
                          <option value="">Date</option>
                          {Date.map((dateValue, dateIndex) => {
                            return (
                              <option key={dateIndex} value={dateValue.date}>
                                {dateValue.date}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </Grid>
                    <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
                      <div>
                        <select
                          className="input"
                          ref={studentBirthdayYearRef}
                          onChange={(e) =>
                            setStudentBirthdayYear(e.target.value)
                          }
                        >
                          <option value="">Year</option>
                          {Years.map((yearValue, yearIndex) => {
                            return (
                              <option key={yearIndex} value={yearValue.year}>
                                {yearValue.year}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                      <div>
                        <p className="input-heading">Gender</p>
                        <select
                          className="input"
                          ref={studentGenderRef}
                          onChange={(e) => setStudentGender(e.target.value)}
                        >
                          <option value="">Gender</option>
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                          <option value="Other">Other</option>
                        </select>
                      </div>
                    </Grid>
                    <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                      <div>
                        <p className="input-heading">Language</p>
                        <select
                          className="input"
                          ref={studentLanguageRef}
                          onChange={(e) => setStudentLanguage(e.target.value)}
                        >
                          <option value="">Language</option>
                          {State.map((stateValue, stateIndex) => {
                            return (
                              <option key={stateIndex} value={stateValue.title}>
                                {stateValue.title}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </Grid>
                  </Grid>

                  <Grid container spacing={2}>
                    <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                      <div>
                        <p className="input-heading">Country</p>
                        <select
                          className="input"
                          ref={studentCountryRef}
                          onChange={(e) => setStudentCountry(e.target.value)}
                        >
                          <option value="">Select</option>
                          {Countries.map((countriesValue, countriesIndex) => {
                            return (
                              <option
                                key={countriesIndex}
                                value={countriesValue.name}
                              >
                                {countriesValue.name}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </Grid>
                    <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                      <div>
                        <p className="input-heading">State</p>
                        <select
                          className="input"
                          ref={studentStateRef}
                          onChange={(e) => setStudentState(e.target.value)}
                        >
                          <option value="">Select</option>
                          {State.map((stateValue, stateIndex) => {
                            return (
                              <option key={stateIndex} value={stateValue.title}>
                                {stateValue.title}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                      <div>
                        <p className="input-heading">City</p>
                        <select
                          className="input"
                          ref={studentCityRef}
                          onChange={(e) => setStudentCity(e.target.value)}
                        >
                          <option value="">City</option>
                          {State.map((stateValue, stateIndex) => {
                            return (
                              <option key={stateIndex} value={stateValue.title}>
                                {stateValue.title}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </Grid>
                    <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                      <div>
                        <p className="input-heading">Mobile Number</p>
                        <div className="country-code-picker-main">
                          <div className="country-code-picker-dropdown-main">
                            <select
                              className="country-code-picker-dropdown"
                              ref={studentCountryCodeRef}
                              onChange={handleDropdownChange}
                            >
                              <option value="">Select</option>
                              {Countries.map(
                                (countriesValue, countriesIndex) => {
                                  return (
                                    <option
                                      key={countriesIndex}
                                      value={countriesValue.alpha2Code}
                                    >
                                      {`${countriesValue.callingCode}  ${countriesValue.name}`}
                                    </option>
                                  );
                                }
                              )}
                            </select>
                          </div>
                          <div className="country-flag-main">
                            {Countries.map(
                              (countriesFlagValue, countriesFlagIndex) => {
                                return (
                                  <div key={countriesFlagIndex}>
                                    {countriesFlagValue.alpha2Code ===
                                      countryCode && (
                                      <img
                                        src={countriesFlagValue.flag}
                                        className="country-flag"
                                      />
                                    )}
                                  </div>
                                );
                              }
                            )}
                            <input
                              type="number"
                              name="mobileNumber"
                              className="mobile-number-input"
                              placeholder="Enter your mobile number"
                              value={studentMobileNumber}
                              ref={studentMobileNumberRef}
                              onChange={(e) =>
                                setStudentMobileNumber(e.target.value)
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                      <div>
                        <p className="input-heading">Address</p>
                        <input
                          type="text"
                          name="address"
                          className="input"
                          placeholder="Enter your address"
                          value={studentAddress}
                          ref={studentAddressRef}
                          onChange={(e) => setStudentAddress(e.target.value)}
                        />
                      </div>
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                      <div>
                        <p className="input-heading">Password</p>
                        <div className="password-input-container">
                          <input
                            type={passwordShow ? "text" : "password"}
                            name="password"
                            className="password-input"
                            placeholder="password"
                            value={studentPassword}
                            ref={studentPasswordRef}
                            onChange={(e) => setStudentPassword(e.target.value)}
                          />
                          <Button
                            onClick={() => setPasswordShow(!passwordShow)}
                            className="password-show-hide-button"
                          >
                            {passwordShow ? (
                              <BsEyeFill color="#a6a6a6" size={20} />
                            ) : (
                              <BsEyeSlashFill color="#a6a6a6" size={20} />
                            )}
                          </Button>
                        </div>
                      </div>
                    </Grid>
                    <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                      <div>
                        <p className="input-heading">Confirm Password</p>
                        <div className="password-input-container">
                          <input
                            type={confirmPasswordShow ? "text" : "password"}
                            name="password"
                            className="password-input"
                            placeholder="password"
                            value={studentConfirmPassword}
                            ref={studentConfirmPasswordRef}
                            onChange={(e) =>
                              setStudentConfirmPassword(e.target.value)
                            }
                          />
                          <Button
                            onClick={() =>
                              setConfirmPasswordShow(!confirmPasswordShow)
                            }
                            className="password-show-hide-button"
                          >
                            {confirmPasswordShow ? (
                              <BsEyeFill color="#a6a6a6" size={20} />
                            ) : (
                              <BsEyeSlashFill color="#a6a6a6" size={20} />
                            )}
                          </Button>
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                      <div>
                        <p className="input-heading">Select your grade</p>
                        <select
                          className="input"
                          ref={studentGradeRef}
                          onChange={(e) => setStudentGrade(e.target.value)}
                        >
                          <option value="">Select</option>
                          <option value="A1">A1</option>
                          <option value="A">A</option>
                          <option value="V">B</option>
                          <option value="C">C</option>
                          <option value="D">D</option>
                          <option value="F">F</option>
                        </select>
                      </div>
                    </Grid>
                  </Grid>
                </Box>
                <Grid container spacing={2}>
                  <Grid item xl={4} lg={4} md={4} sm={12} xs={12}></Grid>
                  <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
                    <Button
                      className="form-button"
                      variant="text"
                      disabled={studentLoading}
                      onClick={StudentDetailsHandler}
                    >
                      {studentLoading ? (
                        <img src={Loading} />
                      ) : (
                        " Save & Continue"
                      )}
                    </Button>
                  </Grid>
                  <Grid item xl={4} lg={4} md={4} sm={12} xs={12}></Grid>
                </Grid>
              </div>
            )}
            {activeTab === "Tutor" && (
              <div className="form-container">
                <p className="register-form-heading">Tutor details</p>
                <Box sx={{ flexGrow: 1 }}>
                  <Grid container spacing={2}>
                    <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                      <div>
                        <p className="input-heading">First name</p>
                        <input
                          type="text"
                          name="firstName"
                          className="input"
                          placeholder="Name"
                          value={tutorFirstName}
                          ref={tutorFirstNameRef}
                          onChange={(e) => setTutorFirstName(e.target.value)}
                        />
                      </div>
                    </Grid>
                    <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                      <div>
                        <p className="input-heading">Last name</p>
                        <input
                          type="text"
                          name="lastName"
                          className="input"
                          placeholder="Name"
                          value={tutorLastName}
                          ref={tutorLastNameRef}
                          onChange={(e) => setTutorLastName(e.target.value)}
                        />
                      </div>
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                      <div>
                        <p className="input-heading">Email Address</p>
                        <input
                          type="email"
                          name="email"
                          required="require"
                          className="input"
                          placeholder="Email address"
                          value={tutorEmail}
                          ref={tutorEmailRef}
                          onChange={(e) => setTutorEmail(e.target.value)}
                        />
                      </div>
                    </Grid>
                  </Grid>
                  <p className="input-heading">birthday</p>
                  <Grid container spacing={2}>
                    <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
                      <div>
                        <select
                          className="input"
                          ref={tutorBirthdatMonthRef}
                          onChange={(e) =>
                            setTutorBirthdayMonth(e.target.value)
                          }
                        >
                          <option value="">Month</option>
                          {Months.map((monthValue, monthIndex) => {
                            return (
                              <option
                                key={monthIndex}
                                value={monthValue.monthName}
                              >
                                {monthValue.monthName}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </Grid>
                    <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
                      <div>
                        <select
                          className="input"
                          ref={tutorBirthdatDateRef}
                          onChange={(e) => setTutorBirthdayDate(e.target.value)}
                        >
                          <option value="">Date</option>
                          {Date.map((dateValue, dateIndex) => {
                            return (
                              <option key={dateIndex} value={dateValue.date}>
                                {dateValue.date}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </Grid>
                    <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
                      <div>
                        <select
                          className="input"
                          ref={tutorBirthdayYearRef}
                          onChange={(e) => setTutorBirthdayYear(e.target.value)}
                        >
                          <option value="">Year</option>
                          {Years.map((yearValue, yearIndex) => {
                            return (
                              <option key={yearIndex} value={yearValue.year}>
                                {yearValue.year}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                      <div>
                        <p className="input-heading">Gender</p>
                        <select
                          className="input"
                          ref={tutorGenderRef}
                          onChange={(e) => setTutorGender(e.target.value)}
                        >
                          <option value="">Gender</option>
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                          <option value="Other">Other</option>
                        </select>
                      </div>
                    </Grid>
                    <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                      <div>
                        <p className="input-heading">Language</p>
                        <select
                          className="input"
                          ref={tutorLanguageRef}
                          onChange={(e) => setTutorLanguage(e.target.value)}
                        >
                          <option value="">Language</option>
                          {State.map((stateValue, stateIndex) => {
                            return (
                              <option key={stateIndex} value={stateValue.title}>
                                {stateValue.title}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </Grid>
                  </Grid>

                  <Grid container spacing={2}>
                    <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                      <div>
                        <p className="input-heading">Country</p>
                        <select
                          className="input"
                          ref={tutorCountryRef}
                          onChange={(e) => setTutorCountry(e.target.value)}
                        >
                          <option value="">Select</option>
                          {Countries.map((countriesValue, countriesIndex) => {
                            return (
                              <option
                                key={countriesIndex}
                                value={countriesValue.name}
                              >
                                {countriesValue.name}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </Grid>
                    <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                      <div>
                        <p className="input-heading">State</p>
                        <select
                          className="input"
                          ref={tutorStateRef}
                          onChange={(e) => setTutorState(e.target.value)}
                        >
                          <option value="">Select</option>
                          {State.map((stateValue, stateIndex) => {
                            return (
                              <option key={stateIndex} value={stateValue.title}>
                                {stateValue.title}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                      <div>
                        <p className="input-heading">City</p>
                        <select
                          className="input"
                          ref={tutorCityRef}
                          onChange={(e) => setTutorCity(e.target.value)}
                        >
                          <option value="">City</option>
                          {State.map((stateValue, stateIndex) => {
                            return (
                              <option key={stateIndex} value={stateValue.title}>
                                {stateValue.title}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </Grid>
                    <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                      <div>
                        <p className="input-heading">Mobile Number</p>
                        <div className="country-code-picker-main">
                          <div className="country-code-picker-dropdown-main">
                            <select
                              className="country-code-picker-dropdown"
                              ref={tutorCountryCodeRef}
                              onChange={handleDropdownChange}
                            >
                              <option value="">Select</option>
                              {Countries.map(
                                (countriesValue, countriesIndex) => {
                                  return (
                                    <option
                                      key={countriesIndex}
                                      value={countriesValue.alpha2Code}
                                    >
                                      {`${countriesValue.callingCode}  ${countriesValue.name}`}
                                    </option>
                                  );
                                }
                              )}
                            </select>
                          </div>
                          <div className="country-flag-main">
                            {Countries.map(
                              (countriesFlagValue, countriesFlagIndex) => {
                                return (
                                  <div key={countriesFlagIndex}>
                                    {countriesFlagValue.alpha2Code ===
                                      countryCode && (
                                      <img
                                        src={countriesFlagValue.flag}
                                        className="country-flag"
                                      />
                                    )}
                                  </div>
                                );
                              }
                            )}

                            <input
                              type="number"
                              name="mobileNumber"
                              className="mobile-number-input"
                              placeholder="Enter your mobile number"
                              value={tutorMobileNumber}
                              ref={tutorMobileNumberRef}
                              onChange={(e) =>
                                setTutorMobileNumber(e.target.value)
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                      <div>
                        <p className="input-heading">Address</p>
                        <input
                          type="text"
                          name="address"
                          className="input"
                          placeholder="Enter your address"
                          value={tutorAddress}
                          ref={tutorAddressRef}
                          onChange={(e) => setTutorAddress(e.target.value)}
                        />
                      </div>
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                      <div>
                        <p className="input-heading">Password</p>
                        <div className="password-input-container">
                          <input
                            type={passwordShow ? "text" : "password"}
                            name="password"
                            className="password-input"
                            placeholder="password"
                            value={tutorPassword}
                            ref={tutorPasswordRef}
                            onChange={(e) => setTutorPassword(e.target.value)}
                          />
                          <Button
                            onClick={() => setPasswordShow(!passwordShow)}
                            className="password-show-hide-button"
                          >
                            {passwordShow ? (
                              <BsEyeFill color="#a6a6a6" size={20} />
                            ) : (
                              <BsEyeSlashFill color="#a6a6a6" size={20} />
                            )}
                          </Button>
                        </div>
                      </div>
                    </Grid>
                    <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                      <div>
                        <p className="input-heading">Confirm Password</p>
                        <div className="password-input-container">
                          <input
                            type={confirmPasswordShow ? "text" : "password"}
                            name="password"
                            className="password-input"
                            placeholder="password"
                            value={tutorConfirmPassword}
                            ref={tutorConfirmPasswordRef}
                            onChange={(e) =>
                              setTutorConfirmPassword(e.target.value)
                            }
                          />
                          <Button
                            onClick={() =>
                              setConfirmPasswordShow(!confirmPasswordShow)
                            }
                            className="password-show-hide-button"
                          >
                            {confirmPasswordShow ? (
                              <BsEyeFill color="#a6a6a6" size={20} />
                            ) : (
                              <BsEyeSlashFill color="#a6a6a6" size={20} />
                            )}
                          </Button>
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                      <div>
                        <p className="input-heading">Add your Education </p>
                        <input
                          type="text"
                          name="education"
                          className="input"
                          placeholder="Education"
                          value={tutorEducation}
                          ref={tutorEducationRef}
                          onChange={(e) => setTutorEducation(e.target.value)}
                        />
                      </div>
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                      <div>
                        <p className="input-heading">
                          what subject are you Expert in?
                        </p>
                        <input
                          type="text"
                          name="Expert"
                          className="input"
                          placeholder="what subject are you Expert in?"
                          value={tutorExpert}
                          ref={tutorExpertRef}
                          onChange={(e) => setTutorExpert(e.target.value)}
                        />
                      </div>
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                      <div>
                        <p className="input-heading">Add your Experience</p>
                        <input
                          type="text"
                          name="experience"
                          className="input"
                          placeholder="Add your Experience"
                          value={tutorExperience}
                          ref={tutorExperienceRef}
                          onChange={(e) => setTutorExperience(e.target.value)}
                        />
                      </div>
                    </Grid>
                  </Grid>
                </Box>
                <Grid container spacing={2}>
                  <Grid item xl={4} lg={4} md={4} sm={12} xs={12}></Grid>
                  <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
                    <Button
                      className="form-button"
                      variant="text"
                      disabled={tutorLoading}
                      onClick={TutorHandler}
                    >
                      {tutorLoading ? (
                        <img src={Loading} />
                      ) : (
                        "  Save & Continue"
                      )}
                    </Button>
                  </Grid>
                  <Grid item xl={4} lg={4} md={4} sm={12} xs={12}></Grid>
                </Grid>
              </div>
            )}
            {activeTab === "Admin Staff" && (
              <div className="form-container">
                <p className="register-form-heading">Admin Staff details</p>
                <Box sx={{ flexGrow: 1 }}>
                  <Grid container spacing={2}>
                    <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                      <div>
                        <p className="input-heading">First name</p>
                        <input
                          type="text"
                          name="firstName"
                          className="input"
                          placeholder="Name"
                          value={staffFirstName}
                          ref={staffFirstNameRef}
                          onChange={(e) => setStaffFirstName(e.target.value)}
                        />
                      </div>
                    </Grid>
                    <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                      <div>
                        <p className="input-heading">Last name</p>
                        <input
                          type="text"
                          name="lastName"
                          className="input"
                          placeholder="Name"
                          value={staffLastName}
                          ref={staffLastNameRef}
                          onChange={(e) => setStaffLastName(e.target.value)}
                        />
                      </div>
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                      <div>
                        <p className="input-heading">Email Address</p>
                        <input
                          type="email"
                          name="email"
                          require="require"
                          className="input"
                          placeholder="Email address"
                          value={staffEmail}
                          ref={staffEmailRef}
                          onChange={(e) => setStaffEmail(e.target.value)}
                        />
                      </div>
                    </Grid>
                    <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                      <div>
                        <p className="input-heading">Staff Role</p>
                        <input
                          type="text"
                          name="role"
                          className="input"
                          placeholder="Enter Staff role"
                          value={staffRole}
                          ref={staffRoleRef}
                          onChange={(e) => setStaffRole(e.target.value)}
                        />
                      </div>
                    </Grid>
                  </Grid>
                  <p className="input-heading">birthday</p>
                  <Grid container spacing={2}>
                    <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
                      <div>
                        <select
                          className="input"
                          ref={staffBirthdayMonthRef}
                          onChange={(e) =>
                            setStaffBirthdayMonth(e.target.value)
                          }
                        >
                          <option value="">Month</option>
                          {Months.map((monthValue, monthIndex) => {
                            return (
                              <option
                                key={monthIndex}
                                value={monthValue.monthName}
                              >
                                {monthValue.monthName}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </Grid>
                    <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
                      <div>
                        <select
                          className="input"
                          ref={staffBirthdayDateRef}
                          onChange={(e) => setStaffBirthdayDate(e.target.value)}
                        >
                          <option value="">Date</option>
                          {Date.map((dateValue, dateIndex) => {
                            return (
                              <option key={dateIndex} value={dateValue.date}>
                                {dateValue.date}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </Grid>
                    <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
                      <div>
                        <select
                          className="input"
                          ref={staffBirthdayYearRef}
                          onChange={(e) => setStaffBirthdayYear(e.target.value)}
                        >
                          <option value="">Year</option>
                          {Years.map((yearValue, yearIndex) => {
                            return (
                              <option key={yearIndex} value={yearValue.year}>
                                {yearValue.year}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                      <div>
                        <p className="input-heading">Gender</p>
                        <select
                          className="input"
                          ref={staffGenderRef}
                          onChange={(e) => setStaffGender(e.target.value)}
                        >
                          <option value="">Gender</option>
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                          <option value="Other">Other</option>
                        </select>
                      </div>
                    </Grid>
                    <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                      <div>
                        <p className="input-heading">Language</p>
                        <select
                          className="input"
                          ref={staffLanguageRef}
                          onChange={(e) => setStaffLanguage(e.target.value)}
                        >
                          <option value="">Language</option>
                          {State.map((stateValue, stateIndex) => {
                            return (
                              <option key={stateIndex} value={stateValue.title}>
                                {stateValue.title}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </Grid>
                  </Grid>

                  <Grid container spacing={2}>
                    <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                      <div>
                        <p className="input-heading">Country</p>
                        <select
                          className="input"
                          ref={staffCountryRef}
                          onChange={(e) => setStaffCountry(e.target.value)}
                        >
                          <option value="">Select</option>
                          {Countries.map((countriesValue, countriesIndex) => {
                            return (
                              <option
                                key={countriesIndex}
                                value={countriesValue.name}
                              >
                                {countriesValue.name}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </Grid>
                    <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                      <div>
                        <p className="input-heading">State</p>
                        <select
                          className="input"
                          ref={staffStateRef}
                          onChange={(e) => setStaffState(e.target.value)}
                        >
                          <option value="">Select</option>
                          {State.map((stateValue, stateIndex) => {
                            return (
                              <option key={stateIndex} value={stateValue.title}>
                                {stateValue.title}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                      <div>
                        <p className="input-heading">City</p>
                        <select
                          className="input"
                          ref={staffCityRef}
                          onChange={(e) => setStaffCity(e.target.value)}
                        >
                          <option value="">City</option>
                          {State.map((stateValue, stateIndex) => {
                            return (
                              <option key={stateIndex} value={stateValue.title}>
                                {stateValue.title}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </Grid>
                    <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                      <div>
                        <p className="input-heading">Mobile Number</p>
                        <div className="country-code-picker-main">
                          <div className="country-code-picker-dropdown-main">
                            <select
                              className="country-code-picker-dropdown"
                              ref={staffCountryCodeRef}
                              onChange={handleDropdownChange}
                            >
                              <option value="">Select</option>
                              {Countries.map(
                                (countriesValue, countriesIndex) => {
                                  return (
                                    <option
                                      key={countriesIndex}
                                      value={countriesValue.alpha2Code}
                                    >
                                      {`${countriesValue.callingCode}  ${countriesValue.name}`}
                                    </option>
                                  );
                                }
                              )}
                            </select>
                          </div>
                          <div className="country-flag-main">
                            {Countries.map(
                              (countriesFlagValue, countriesFlagIndex) => {
                                return (
                                  <div key={countriesFlagIndex}>
                                    {countriesFlagValue.alpha2Code ===
                                      countryCode && (
                                      <img
                                        src={countriesFlagValue.flag}
                                        className="country-flag"
                                      />
                                    )}
                                  </div>
                                );
                              }
                            )}

                            <input
                              type="number"
                              name="mobileNumber"
                              className="mobile-number-input"
                              placeholder="Enter your mobile number"
                              value={staffMobileNumber}
                              ref={staffMobileNumberRef}
                              onChange={(e) =>
                                setStaffMobileNumber(e.target.value)
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                </Box>
                <Grid container spacing={2}>
                  <Grid item xl={4} lg={4} md={4} sm={12} xs={12}></Grid>
                  <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
                    <Button
                      className="form-button"
                      variant="text"
                      disabled={staffLoading}
                      onClick={AdminStaffHandler}
                    >
                      {staffLoading ? (
                        <img src={Loading} />
                      ) : (
                        " Save & Continue"
                      )}
                    </Button>
                  </Grid>
                  <Grid item xl={4} lg={4} md={4} sm={12} xs={12}></Grid>
                </Grid>
              </div>
            )}
          </>
        ) : (
          <>
            <p className="register-from-heading">Add your certificate</p>
            <div className="register-file-upload-section">
              <Box sx={{ flexGrow: 1 }}>
                <Grid container spacing={2}>
                  <Grid item xl={3} lg={3} md={6} sm={6} xs={12}>
                    <div>
                      <p className="input-heading">Add your logo</p>
                      <label htmlFor="icon-button-file">
                        <Input
                          accept="image/*"
                          id="icon-button-file"
                          type="file"
                        />
                        <IconButton
                          color="primary"
                          aria-label="upload picture"
                          component="span"
                          className="icon-button-file"
                        >
                          <BsPlusLg color="#7C7C7C" size={30} />
                        </IconButton>
                      </label>
                      <p className="upload-file-requirements">
                        (Upload only png,jpg,pdf)
                      </p>
                    </div>
                  </Grid>
                  <Grid item xl={3} lg={3} md={6} sm={6} xs={12}>
                    <div>
                      <p className="input-heading">Add your License</p>
                      <label htmlFor="icon-button-file">
                        <Input
                          accept="image/*"
                          id="icon-button-file"
                          type="file"
                        />
                        <IconButton
                          color="primary"
                          aria-label="upload picture"
                          component="span"
                          className="icon-button-file"
                        >
                          <BsPlusLg color="#7C7C7C" size={30} />
                        </IconButton>
                      </label>
                      <p className="upload-file-requirements">
                        (Upload only png,jpg,pdf)
                      </p>
                    </div>
                  </Grid>
                  <Grid item xl={3} lg={3} md={6} sm={6} xs={12}>
                    <div>
                      <p className="input-heading">add your Tax certificate</p>
                      <label htmlFor="icon-button-file">
                        <Input
                          accept="image/*"
                          id="icon-button-file"
                          type="file"
                        />
                        <IconButton
                          color="primary"
                          aria-label="upload picture"
                          component="span"
                          className="icon-button-file"
                        >
                          <BsPlusLg color="#7C7C7C" size={30} />
                        </IconButton>
                      </label>
                      <p className="upload-file-requirements">
                        (Upload only png,jpg,pdf)
                      </p>
                    </div>
                  </Grid>
                  <Grid item xl={3} lg={3} md={6} sm={6} xs={12}>
                    <div>
                      <p className="input-heading">Add your certifications</p>
                      <label htmlFor="icon-button-file">
                        <Input
                          accept="image/*"
                          id="icon-button-file"
                          type="file"
                        />
                        <IconButton
                          color="primary"
                          aria-label="upload picture"
                          component="span"
                          className="icon-button-file"
                        >
                          <BsPlusLg color="#7C7C7C" size={30} />
                        </IconButton>
                      </label>
                      <p className="upload-file-requirements">
                        (Upload only png,jpg,pdf)
                      </p>
                    </div>
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xl={3} lg={3} md={6} sm={6} xs={12}>
                    <div>
                      <p className="input-heading">Add your Tax certificate</p>
                      <label htmlFor="icon-button-file">
                        <Input
                          accept="image/*"
                          id="icon-button-file"
                          type="file"
                        />
                        <IconButton
                          color="primary"
                          aria-label="upload picture"
                          component="span"
                          className="icon-button-file"
                        >
                          <BsPlusLg color="#7C7C7C" size={30} />
                        </IconButton>
                      </label>
                      <p className="upload-file-requirements">
                        (Upload only png,jpg,pdf)
                      </p>
                    </div>
                  </Grid>
                  <Grid item xl={3} lg={3} md={6} sm={6} xs={12}>
                    <div>
                      <p className="input-heading">Add your brochure</p>
                      <label htmlFor="icon-button-file">
                        <Input
                          accept="image/*"
                          id="icon-button-file"
                          type="file"
                        />
                        <IconButton
                          color="primary"
                          aria-label="upload picture"
                          component="span"
                          className="icon-button-file"
                        >
                          <BsPlusLg color="#7C7C7C" size={30} />
                        </IconButton>
                      </label>
                      <p className="upload-file-requirements">
                        (Upload only png,jpg,pdf)
                      </p>
                    </div>
                  </Grid>
                  <Grid item xl={3} lg={3} md={6} sm={6} xs={12}>
                    <div>
                      <p className="input-heading">your brochure</p>
                      <img
                        src={Certificate}
                        className="register-uploaded-file-show"
                      />
                    </div>
                  </Grid>
                  <Grid item xl={3} lg={3} md={6} sm={6} xs={12}>
                    <div>
                      <p className="input-heading">your Tax certificate</p>
                      <img
                        src={Certificate}
                        className="register-uploaded-file-show"
                      />
                    </div>
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xl={4} lg={4} md={4} sm={12} xs={12}></Grid>
                  <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
                    <Button
                      className="form-button"
                      variant="text"
                      disabled={submitLoading}
                      onClick={SubmitHandler}
                    >
                      {submitLoading ? <img src={Loading} /> : "Submit"}
                    </Button>
                  </Grid>
                  <Grid item xl={4} lg={4} md={4} sm={12} xs={12}></Grid>
                </Grid>
              </Box>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
export default Register;
